// extracted by mini-css-extract-plugin
export var alternateTextStyle = "style-mod--alternate-text-style--f3741";
export var infoDescription = "style-mod--info-description--0c8cf";
export var infoLinkableText = "style-mod--info-linkable-text--2faa2";
export var infoSection = "style-mod--info-section--ed89e";
export var infoTitle = "style-mod--info-title--39ed1";
export var modalClose = "style-mod--modal-close--29a2c";
export var modalCloseContainer = "style-mod--modal-close-container--02038";
export var modalCloseDesktop = "style-mod--modal-close-desktop--167e8";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--0f5d0";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--15217";
export var modalCloseResponsive = "style-mod--modal-close-responsive--9e32e";
export var modalParagraph = "style-mod--modal-paragraph--d2724";
export var modalTitle = "style-mod--modal-title--4627e";
export var shortInfoBody = "style-mod--short-info-body--a2666";
export var shortInfoContent = "style-mod--short-info-content--1d9b5";
export var shortInfoImage = "style-mod--short-info-image--b2717";
export var shortInfoImageCover = "style-mod--short-info-image-cover--85fba";
export var shortInfoImageDesktop = "style-mod--short-info-image-desktop--dfae7";
export var shortInfoImageMobile = "style-mod--short-info-image-mobile--53968";
export var shortInfoModal = "style-mod--short-info-modal--5c635";
export var shortInfoParagraph = "style-mod--short-info-paragraph--51b8d";
export var shortInfoText = "style-mod--short-info-text--7c7ad";
export var shortInfoTextImage = "style-mod--short-info-text-image--7bcb5";
export var shortInfoTitle = "style-mod--short-info-title--16cfc";